var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconDiscount = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "1 1 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1923 -1279)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M617.207,176.207l-9,9a1,1,0,0,1-1.414-1.414l9-9a1,1,0,0,1,1.414,1.414ZM619,184a3,3,0,1,1-3-3A3,3,0,0,1,619,184Zm-2,0a1,1,0,1,0-1,1A1,1,0,0,0,617,184Zm-9-5a3,3,0,1,1,3-3A3,3,0,0,1,608,179Zm0-2a1,1,0,1,0-1-1A1,1,0,0,0,608,177Z",
    transform: "translate(1323 1111)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDiscount, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-discount.4932b2ac.svg";
export { ForwardRef as ReactComponent };